import { render, staticRenderFns } from "./uploading.vue?vue&type=template&id=b72c0986&scoped=true&"
import script from "./uploading.vue?vue&type=script&lang=js&"
export * from "./uploading.vue?vue&type=script&lang=js&"
import style0 from "./uploading.vue?vue&type=style&index=0&id=b72c0986&lang=scss&scoped=true&"
import style1 from "./uploading.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72c0986",
  null
  
)

export default component.exports